module.exports = __webpack_public_path__ + "img/blank_user.7a3e7cd8.jpg";